export interface FAQItem {
  question: string;
  answer: string;
}

export const faqList: FAQItem[] = [
  {
    question: '黄瓜视频在线需要付费吗？',
    answer: '完全不需要！黄瓜视频在线是一款完全免费的在线视频播放平台。所有视频内容均对用户免费开放，无任何隐藏收费。我们始终坚持"免费高清"的核心理念，让每一位用户都能无负担地享受优质视频内容。',
  },
  {
    question: '黄瓜视频在线支持哪些设备观看？',
    answer: '黄瓜视频在线支持多终端播放，包括：电脑端（Windows/Mac浏览器）、手机端（iOS/Android浏览器）、平板电脑、智能电视等。只要您的设备能打开浏览器，就能随时随地畅享黄瓜视频在线的内容。',
  },
  {
    question: '视频加载慢或卡顿怎么办？',
    answer: '视频播放卡顿通常与您的网络状况有关。建议：1) 检查网络连接是否稳定；2) 尝试降低画质（在播放器右下角设置）；3) 关闭其他占用带宽的应用；4) 切换至WiFi网络。如果问题持续，可尝试清除浏览器缓存后重新加载。',
  },
  {
    question: '黄瓜视频在线的视频画质如何？',
    answer: '黄瓜视频在线支持从流畅到4K超清的多档画质选择。大部分热门内容已支持4K超清画质，配合HDR技术，能够呈现细腻的画面细节和丰富的色彩层次。用户可根据自己的网络状况和设备性能自由选择合适的画质。',
  },
  {
    question: '可以在黄瓜视频在线下载视频吗？',
    answer: '目前黄瓜视频在线支持在线缓存功能，用户可以将喜欢的视频缓存到本地，在没有网络的环境下也能观看。缓存功能完全免费，缓存的视频会保存在应用中，不会占用额外的存储空间管理权限。',
  },
  {
    question: '黄瓜视频在线的内容是否正版？',
    answer: '是的！黄瓜视频在线与众多内容提供商建立了正式合作关系，平台上的所有视频内容均获得了合法的播放授权。我们尊重知识产权，致力于为用户提供正版、安全、可靠的视频内容服务。',
  },
  {
    question: '如何搜索我想看的视频？',
    answer: '在黄瓜视频在线首页顶部的搜索框中输入关键词（如剧名、演员名、类型等），即可快速找到相关内容。您也可以通过首页的分类导航，按照电视剧、电影、综艺、动漫等不同类别浏览感兴趣的内容。',
  },
  {
    question: '黄瓜视频在线有广告吗？',
    answer: '为维持平台运营，黄瓜视频在线在部分内容中会展示少量广告。但我们严格控制广告时长和频次，确保不会过度影响您的观影体验。所有注册用户默认享受减少广告特权。',
  },
  {
    question: '如何在黄瓜视频在线注册账号？',
    answer: '注册非常简单！点击页面右上角的"登录/注册"按钮，使用手机号或邮箱即可快速完成注册。注册后您可以享受收藏视频、观看历史同步、弹幕互动等更多个性化功能。',
  },
];